import { createSignal, For } from 'solid-js';
import { type SetStoreFunction } from 'solid-js/store';
import { twclsx, Icons, Input } from '.';
import { type Validator } from '../globals';

export type ListProps<T> = {
  type: string;
  key: string;
  label: string;
  values: string[];
  class?: string;
  onUpdate: SetStoreFunction<T>;
  validators?: Validator[];
};

// eslint-disable-next-line comma-spacing
const List = <T,>(props: ListProps<T>) => {
  const [inputValue, setInputValue] = createSignal('');

  const handleAddData = (event: Event) => {
    event.preventDefault();
    const isInputValueValid = props.validators?.every(validator => {
      if (typeof validator === 'function') {
        return validator(inputValue());
      }

      return validator.safeParse(inputValue()).success;
    });

    if (inputValue() && isInputValueValid) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      props.onUpdate(props.key as any, props.values.length as any, inputValue() as any);
      setInputValue('');
    }
  };

  const handleRemoveData = (d: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props.onUpdate(props.key as any, ((values: string[]) => values.filter((v: string) => v !== d)) as any);
  };

  return (
    <div class={props.class}>
      <div class={twclsx('flex', 'items-end', 'mb-2')}>
        <Input
          type={props.type}
          id={props.key}
          name={props.key}
          placeholder={props.label}
          class={twclsx('w-full')}
          label={props.label}
          value={inputValue()}
          onChange={e => setInputValue(e.currentTarget.value)}
          validators={props.validators}
        />
        <button onClick={handleAddData} class={twclsx('px-2 mb-2 dark:text-white')}>
          <Icons.Add class={twclsx('inline', 'w-8', 'h-8')} />
        </button>
      </div>
      <div class={twclsx('border', 'px-3', 'mt-3', 'rounded-lg')}>
        <For each={props.values}>
          {value => (
            <div id={value} class={twclsx('border-b', 'flex', 'justify-between', 'py-2')}>
              <span class={twclsx('flex', 'items-center dark:text-white')}>
                <Icons.Email class={twclsx('w-4', 'h-4', 'mr-2')} /> {value}
              </span>
              <button
                class={twclsx('px-4', 'text-red-600')}
                onClick={(event: Event) => {
                  event.preventDefault();
                  handleRemoveData(value);
                }}
              >
                <Icons.Remove class={twclsx('w-4', 'h-4')} />
              </button>
            </div>
          )}
        </For>
      </div>
    </div>
  );
};

export default List;
